import { LocalizationsTable } from './LocalizationsTable';

export const LocalizationsList: React.FC = () => {
  return <LocalizationsTable />;
};
